import React from "react";
import "./App.css";
import Layout from "./layout/Layout";
import { Switch, Route, BrowserRouter } from "react-router-dom";
import SignInPage from "./pages/auth/signin/SignInPage";

import {
  SIGNIN_PATH,
  USER_ACCOUNT_PATH,
  USER_HOME_PATH,
  ADMIN_ACCOUNT_PATH,
  ADMIN_RESTAURANT_PATH,
  USER_PROMOS_PATH,
  USER_DRIVERS_PATH,
  USER_ORDER_PATH,
  USER_ORDERS_PATH,
  USER_GENERAL_PATH,
  TERMS_PATH,
  PRIVACY_PATH,
  PRIVACY_DRIVER_PATH,
  RECEPTIONIST_ACCOUNT_PATH,
  RECEPTIONIST_ORDERS_PATH,
  RECEPTIONIST_ORDER_PATH,
  RECEPTIONIST_HOME_PATH,
  ADMIN_HOME_PATH,
  ADMIN_MENU_PATH,
} from "./constants/paths";
import MyAccountPage from "./pages/profile/my-account/MyAccountPage";
import UserIsNotAuthRoute from "./components/common/UserIsNotAuthRoute";
import UserIsAuthRoute from "./components/common/UserIsAuthRoute";
import UserIsAdminRoute from "./components/common/UserIsAdminRoute";
import AdminAccountPage from "./pages/admin/AdminAccountPage";
import RestaurantPage from "./pages/admin/RestaurantPage";
import MyRestaurantPage from "./pages/app/restaurant/MyRestaurantPage";
import SalePromotionsPage from "./pages/app/restaurant/SalePromotionsPage";
import MenuPage from "./pages/app/restaurant/MenuPage";
import DriverPage from "./pages/app/restaurant/DriverPage";
import OrderPage from "./pages/app/orders/OrderPage";
import OrdersPage from "./pages/app/orders/OrdersPage";
import GeneralPage from "./pages/app/restaurant/GeneralPage";
import TermsPage from "./pages/general/TermsPage";
import PrivacyPolicy from "./pages/general/PrivacyPolicy";
import NewMenuPage from "./pages/app/restaurant/MenuPage";
import SectionPage from "./pages/app/restaurant/SectionPage";
import ProductPage from "./pages/app/restaurant/ProductPage";
import NewProductPage from "./pages/app/restaurant/NewProductPage";
import NewSectionPage from "./pages/app/restaurant/NewSectionPage";
import PrivacyPolicyDriver from "./pages/general/PrivacyPolicyDriver";
import UserIsReceptionistRoute from "./components/common/UserIsReceptionistRoute";
import ReceptionGeneralPage from "./pages/app/receptionist/ReceptionGeneralPage";
import ReceptionOrderPage from "./pages/app/receptionist/ReceptionOrderPage";
import ReceptionOrdersPage from "./pages/app/receptionist/ReceptionOrdersPage";
import AdminHomePage from "./pages/admin/AdminHomePage";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Switch>
          <UserIsNotAuthRoute exact path={SIGNIN_PATH}>
            <SignInPage />
          </UserIsNotAuthRoute>
          <Route exact path={TERMS_PATH}>
            <TermsPage />
          </Route>
          <Route exact path={PRIVACY_PATH}>
            <PrivacyPolicy />
          </Route>
          <Route exact path={PRIVACY_DRIVER_PATH}>
            <PrivacyPolicyDriver />
          </Route>

          <UserIsAuthRoute exact path={USER_HOME_PATH}>
            <MyRestaurantPage />
          </UserIsAuthRoute>
          <UserIsAuthRoute exact path={USER_ORDER_PATH}>
            <OrderPage />
          </UserIsAuthRoute>
          <UserIsAuthRoute exact path={USER_ORDERS_PATH}>
            <OrdersPage />
          </UserIsAuthRoute>
          <UserIsAuthRoute exact path={USER_ACCOUNT_PATH}>
            <MyAccountPage />
          </UserIsAuthRoute>
          <UserIsAuthRoute exact path={USER_DRIVERS_PATH}>
            <DriverPage />
          </UserIsAuthRoute>
          <UserIsAuthRoute exact path={USER_GENERAL_PATH}>
            <GeneralPage />
          </UserIsAuthRoute>

          <UserIsAdminRoute exact path={ADMIN_HOME_PATH}>
            <AdminHomePage />
          </UserIsAdminRoute>
          <UserIsAdminRoute exact path={ADMIN_RESTAURANT_PATH}>
            <RestaurantPage />
          </UserIsAdminRoute>
          <UserIsAdminRoute exact path={ADMIN_MENU_PATH}>
            <MenuPage />
          </UserIsAdminRoute>
          <UserIsAdminRoute exact path={`${ADMIN_MENU_PATH}/seccion/nuevo`}>
            <NewSectionPage />
          </UserIsAdminRoute>
          <UserIsAdminRoute exact path={`${ADMIN_MENU_PATH}/seccion/:id`}>
            <SectionPage />
          </UserIsAdminRoute>
          <UserIsAdminRoute
            exact
            path={`${ADMIN_MENU_PATH}/seccion/:section_id/producto/nuevo`}
          >
            <NewProductPage />
          </UserIsAdminRoute>
          <UserIsAdminRoute
            exact
            path={`${ADMIN_MENU_PATH}/seccion/:section_id/producto/:product_id`}
          >
            <ProductPage />
          </UserIsAdminRoute>
          <UserIsAdminRoute exact path={ADMIN_ACCOUNT_PATH}>
            <AdminAccountPage />
          </UserIsAdminRoute>
          <UserIsAdminRoute exact path={USER_PROMOS_PATH}>
            <SalePromotionsPage />
          </UserIsAdminRoute>

          <UserIsReceptionistRoute exact path={RECEPTIONIST_HOME_PATH}>
            <ReceptionGeneralPage />
          </UserIsReceptionistRoute>
          <UserIsReceptionistRoute exact path={RECEPTIONIST_ORDERS_PATH}>
            <ReceptionOrdersPage />
          </UserIsReceptionistRoute>
          <UserIsReceptionistRoute exact path={RECEPTIONIST_ACCOUNT_PATH}>
            <MyAccountPage />
          </UserIsReceptionistRoute>
          <UserIsReceptionistRoute
            exact
            path={`${RECEPTIONIST_ORDERS_PATH}/:id`}
          >
            <ReceptionOrderPage />
          </UserIsReceptionistRoute>
        </Switch>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
